export default function CTASection() {
  return (
    <section className="relative w-full h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20assorted%20fashion%20lifestyle%20items%20including%20leather%20goods%20sunglasses%20watch%20and%20fragrance%20bottles%20arranged%20on%20warm%20sand%20colored%20linen%20fabric%2C%20scattered%20dried%20eucalyptus%20and%20pampas%20grass%2C%20soft%20afternoon%20light%2C%20organic%20boho%20aesthetic%2C%20editorial%20product%20styling%2C%20rich%20earth%20tones%20and%20neutral%20palette&width=1800&height=1200&seq=cta-bg-v2-2026jul&orientation=landscape"
          alt="Hipobuy Sheet organized product finds"
          className="w-full h-full object-cover object-top"
          title="Hipobuy Sheet - Get Organized Finds"
        />
        <div className="absolute inset-0 bg-foreground-950/50"></div>
      </div>

      <div className="relative z-10 text-center px-6 w-full">
        <h2 className="font-heading text-4xl md:text-7xl font-extrabold text-background-50 tracking-widest uppercase mb-5">
          Get Organized Finds
        </h2>
        <p className="text-background-50/80 text-sm md:text-base max-w-lg mx-auto leading-relaxed mb-10">
          Curated product spreadsheets for U.S. &amp; EU shoppers
          <br />
          Updated daily with new drops
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="group inline-flex items-center gap-3 px-8 py-4 rounded-full bg-foreground-950 text-background-50 hover:bg-foreground-900 transition-all duration-200 cursor-pointer"
        >
          <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 flex-shrink-0 group-hover:scale-110 transition-transform duration-200">
            <i className="ri-shopping-bag-line text-lg"></i>
          </span>
          <span className="text-sm font-bold uppercase tracking-wider whitespace-nowrap">Buy It Now</span>
          <i className="ri-arrow-right-up-line text-lg w-5 h-5 flex items-center justify-center"></i>
        </a>
      </div>
    </section>
  );
}